import Task from "./models/task";
import TaskQueryService from "../entities/task-query-service";
import formatDate from "@/helpers/formatDate";

export default class TaskService {
  public constructor(private tasks: TaskQueryService) {}

  public async search(
    date: Date,
    hiddenDoneTasks: boolean = false,
    orderBy: string = "",
    userIds: string[]|number[] = [],
    staffIds: string[]|number[] = [],
    userStaffIds: string[]|number[] = [],
  ): Promise<TaskQueryResponse> {
    const tasks = hiddenDoneTasks
      ? await this.tasks.undone(userIds, staffIds, userStaffIds, orderBy)
      : await this.tasks.all(userIds, staffIds, userStaffIds, orderBy);

    return tasks.map(t => ({
      ...t,
      id: String(t.id),
      dueDate: t.dueDate ? formatDate(t.dueDate, !!t.time) : "",
      overdue: t.isOverdue(date)
    })) as TaskQueryResponse;
  }
}

type TaskQueryResponse = Task[];
